/*eslint-disable*/
import Dashboard from 'views/Dashboard/Dashboard.jsx';

// @material-ui/icons
import {
	Dashboard as DashboardIcon,
	Apps,
	People,
	Assignment,
	BubbleChart,
	Person,
	Chat,
	PlaylistAddCheck
} from '@material-ui/icons';

// Broker views
import Profile from 'views/Profile/Profile.jsx';
import ClientForm from 'views/Clients/components/ClientForm.jsx';
import ManageClients from 'views/Clients/components/ManageClients.jsx';
import ClientEditForm from 'views/Clients/components/ClientEditForm.jsx';
import ClientEditForm_EliteWealth from 'views/Clients/components/ClientEditForm_EliteWealth.jsx';
import ClientHistory_EliteWealth from 'views/Clients/components/ClientHistory_EliteWealth.jsx';
import ClientForQuote from 'views/Clients/components/ClientForQuote.jsx';
import QuoteHistory from 'views/Quote/QuoteHistory.jsx';
import ResultsPage from 'views/Quote/ResultsPage.jsx';
import AssistantAssignment from 'views/Brokers/AssistantAssignment.jsx';

//Brokerage views
import BrokerageAdminProfile from 'views/Profile/BrokerageAdminProfile.jsx';
import BrokerageBrokerProfile from 'views/Profile/BrokerageBrokerProfile.jsx';
import Subscription from 'views/Subscription/Subscription.jsx';
import UserManagement from 'views/UserManagement/UserManagement.jsx';

//Assistant views
import AssistantProfile from 'views/Profile/Assistant/AssistantProfile.jsx';
import BrokerAssignment from 'views/Assistant/BrokerAssignment.jsx';
import ManageClientsGateway from 'views/Assistant/ManageClients.jsx';
import AddClientGateway from 'views/Assistant/AddClient.jsx';
import QuoteHistoryGateway from 'views/Assistant/QuoteHistory.jsx';

import CompanyLoginDetails from 'views/Profile/CompanyLoginDetails.jsx';

//FNA
import CreateFNA from 'views/Fna/fna_wizard.jsx';
import FnaResultsPage from 'views/Fna/ResultsPage/FnaResultsPage.jsx';
import FnaResultsJson from 'views/Fna/FnaResultsJson.jsx';

import FnaHistory from 'views/Fna/FnaHistory.jsx';
import ClientForFna from 'views/Fna/ClientForFna.jsx';

//BNA
import CreateBNA from 'views/Bna/bna_wizard.jsx';

//Messaging
import ClientMessages from 'views/Messaging/ClientMessages.jsx';
import ClientMessageHistory from 'views/Messaging/ClientMessageHistory.jsx';

import UserTodos from 'views/Todos/UserTodos.jsx';

//Payment
import PaymentPlayground from 'views/Payment/PaymentPlayground.jsx';
import PaymentSuccess from 'views/Payment/PaymentSuccess.jsx';
import PaymentFailed from 'views/Payment/PaymentFailed.jsx';

//
import ClientDetailView from 'views/Clients/ClientDetail/ClientDetailView.jsx';

import EditSubscription from 'views/Subscription/EditSubscription.jsx';

import QuoteWizard from 'views/Quote/QuoteWizard/QuoteWizard.jsx';

import QuoteWizardMedical from 'views/MedicalAidQuote/QuoteWizard/QuoteWizardMedical.jsx';

import AdvancedSearch from 'views/Clients/components/advanced_search/AdvancedSearch.jsx';

var dashRoutes = [
	{
		path: '/app/home',
		name: 'Home',
		icon: DashboardIcon,
		component: Dashboard,
		userTypes: ['2', '3', '6']
	},

	{
		path: '/app/paymentplayground',
		name: 'Todo',
		hidden: true,
		icon: PlaylistAddCheck,
		component: PaymentPlayground,
		userTypes: ['2', '3']
	},
	{
		path: '/app/paymentsuccess',
		name: 'Todo',
		hidden: true,
		icon: PlaylistAddCheck,
		component: PaymentSuccess,
		userTypes: ['2', '3']
	},
	{
		path: '/app/paymentfailed',
		name: 'Todo',
		hidden: true,
		icon: PlaylistAddCheck,
		component: PaymentFailed,
		userTypes: ['2', '3']
	},

	{
		path: '/app/clientdetail',
		name: 'Client Detail View',
		hidden: true,
		icon: PlaylistAddCheck,
		component: ClientDetailView,
		userTypes: ['2', '3', '6']
	},
	{
		path: '/app/brokerageAdminProfile',
		name: 'Profile',
		icon: Person,
		component: BrokerageAdminProfile,
		userTypes: ['1']
	},
	{
		collapse: true,
		path: '/app/profile',
		name: 'Profile',
		state: 'openProfile',
		icon: Apps,
		userTypes: ['1', '2', '3', '6',''],
		views: [
			{
				path: '/app/userProfile',
				name: 'Profile',
				component: Profile,
				userTypes: ['2']
			},
			{
				path: '/app/brokerageBrokerProfile',
				name: 'Profile',
				component: BrokerageBrokerProfile,
				userTypes: ['3']
			},
			{
				path: '/app/subscription',
				name: 'Subscription',
				hidden: true,
				component: Subscription,
				userTypes: ['3']
			},
			{
				path: '/app/editsubscription',
				name: 'Edit Subscription',
				hidden: true,
				component: EditSubscription,
				userTypes: ['3']
			},
			{
				path: '/app/AssistantProfile',
				name: 'Profile',
				component: AssistantProfile,
				userTypes: ['6']
			},
			{
				path: '/app/companylogindetails',
				name: 'FSP Login Detail',
				component: CompanyLoginDetails,
				userTypes: ['2', '3', '6','']
			},
			{
				path: '/app/usermanagement',
				name: 'Brokerage Users',
				component: UserManagement,
				userTypes: ['1', '3']
			},
			{
				path: '/app/assistantassignment',
				name: 'Assistant Assignment',
				component: AssistantAssignment,
				userTypes: ['2', '3']
			},
			{
				path: '/app/brokerassignment',
				name: 'Broker Assignment',
				component: BrokerAssignment,
				userTypes: ['6']
			}
		]
	},
	{
		path: '/app/clientmessagehistory',
		name: 'Client Messages',
		icon: Chat,
		component: ClientMessageHistory,
		userTypes: ['2', '3', '6']
	},
	{
		path: '/app/ManageClients',
		name: 'Clients',
		icon: People,
		component: ManageClients,
		userTypes: ['2', '3']
	},
	{
		path: '/app/manageclientsassistant',
		name: 'Clients',
		icon: People,
		component: ManageClientsGateway,
		userTypes: ['6']
	},
	{
		collapse: true,
		path: '/app/clients',
		hidden: true,
		name: 'Clients',
		state: 'openClients',
		icon: People,
		userTypes: ['2', '3', '6'],
		views: [
			{
				path: '/app/CreateClient',
				alternate: '/app/ManageClients',
				name: 'Add Client',
				mini: '+',
				component: ClientForm,
				userTypes: ['2', '3']
			},
			{
				path: '/app/ManageClients',
				name: 'Manage Clients',
				mini: '-',
				component: ManageClients,
				userTypes: ['2', '3']
			},
			{
				path: '/app/createclientassistant',
				alternate: '/app/CreateClient',
				name: 'Add Client',
				mini: '+',
				component: AddClientGateway,
				userTypes: ['6']
			},
			{
				path: '/app/manageclientsassistant',
				alternate: '/app/ManageClients',
				name: 'Manage Clients',
				mini: '-',
				component: ManageClientsGateway,
				userTypes: ['6']
			}
		]
	},

	{
		path: '/app/EditClient',
		name: 'Edit Client',
		icon: DashboardIcon,
		component: ClientEditForm,
		hidden: true,
		userTypes: ['2', '3']
	},
	{
		path: '/app/EditClientEliteWealth',
		name: 'Edit Client Elite',
		icon: DashboardIcon,
		component: ClientEditForm_EliteWealth,
		hidden: true,
		userTypes: ['2', '3']
	},
	{
		path: '/app/ClientHistoryEliteWealth',
		name: 'Edit Client Elite',
		icon: DashboardIcon,
		component: ClientHistory_EliteWealth,
		hidden: true,
		userTypes: ['2', '3']
	},
	{
		path: '/app/advancedsearch',
		name: 'Advanced Search',
		icon: DashboardIcon,
		component: AdvancedSearch,
		hidden: true,
		userTypes: ['2', '3', '6']
	},
	{
		path: '/app/history',
		name: 'Quotes',
		icon: Assignment,
		component: QuoteHistory,
		userTypes: ['2', '3']
	},

	{
		path: '/app/quotehistoryassistant',
		alternate: '/app/history',
		name: 'Quotes',
		icon: Assignment,
		component: QuoteHistoryGateway,
		userTypes: ['6']
	},
	{
		path: '/app/new',
		name: 'New Quote',
		hidden: true,
		component: ClientForQuote,
		userTypes: ['2', '3', '6']
	},
	
	{
		path: '/app/usertodos',
		name: 'To Do',
		hidden: false,
		icon: PlaylistAddCheck,
		component: UserTodos,
		userTypes: ['2', '3', '6']
	},
	{
		path: '/app/quote',
		name: 'New Quote',
		hidden: true,
		icon: Assignment,
		component: QuoteWizard,
		userTypes: ['2', '3', '6']
	},
	{
		path: '/app/quotemedical',
		name: 'New Quote',
		hidden: true,
		icon: Assignment,
		component: QuoteWizardMedical,
		userTypes: ['2', '3', '6']
	},
	{
		path: '/app/newfna',
		name: 'FNA (in construction)',
		hidden: true,
		icon: BubbleChart,
		component: CreateFNA,
		userTypes: ['2', '3', '6']
	},
	{
		path: '/app/fnahistory',
		name: 'FNA (ALPHA)',
		hidden: false,
		icon: BubbleChart,
		component: FnaHistory,
		userTypes: ['2', '3', '6']
	},
	{
		path: '/app/clientforfna',
		name: 'clientforfna',
		hidden: true,
		icon: BubbleChart,
		component: ClientForFna,
		userTypes: ['2', '3', '6']
	},
	{
		path: '/app/fnaresults',
		name: 'FNA (in construction)',
		hidden: true,
		icon: BubbleChart,
		component: FnaResultsPage,
		userTypes: ['2', '3']
	},
	{
		path: '/app/fnaresultsjson',
		name: 'FNA',
		hidden: true,
		icon: BubbleChart,
		component: FnaResultsJson,
		userTypes: ['2', '3']
	},
	{
		path: '/app/newbna',
		name: 'BNA (in EARLY construction)',
		hidden: false,
		icon: BubbleChart,
		component: CreateBNA,
		userTypes: ['2', '3', '6']
	},

	{
		path: '/app/quoteresult',
		name: 'Quote Result',
		icon: DashboardIcon,
		component: ResultsPage,
		hidden: true,
		userTypes: ['2', '3']
	},
	{
		path: '/app/clientmessages',
		name: 'Client Messages',
		icon: DashboardIcon,
		component: ClientMessages,
		hidden: true,
		userTypes: ['2', '3', '6']
	},
	{
		path: '/app/',
		name: 'Home',
		hidden: true,
		icon: DashboardIcon,
		component: Dashboard,
		userTypes: ['2', '3', '6']
	}
];
export default dashRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx